import { Reveal } from "@/components/Reveal";

export const Philosophy = () => {
  return (
    <section
      className="py-32 md:py-44"
      data-testid="philosophy-section"
    >
      <div className="max-w-4xl mx-auto px-6 text-center">
        <Reveal>
          <p className="text-xs tracking-[0.35em] uppercase text-[#7D1B56] mb-12">
            The Philosophy
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-serif-display font-light text-4xl sm:text-5xl lg:text-6xl leading-tight text-[#02515A]">
            Goodbye can be <span className="italic">a gift.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-8 flex justify-center" aria-hidden="true">
            <div className="w-16 h-px bg-[#7D1B56]" />
          </div>
        </Reveal>
        <Reveal delay={0.3}>
          <p className="mt-12 text-base md:text-lg font-light leading-loose text-[#3F6B72] max-w-2xl mx-auto">
            Too often, the words that matter most are said at funerals — when
            they should have been said in kitchens, on walks, in messages that
            were never sent.
          </p>
        </Reveal>
        <Reveal delay={0.4}>
          <p className="mt-8 text-base md:text-lg font-light leading-loose text-[#3F6B72] max-w-2xl mx-auto">
            A living goodbye changes that. It is a moment — designed while you
            are still here to receive it — where love is witnessed out loud, and
            the people who matter hear exactly what they mean to you.
          </p>
        </Reveal>
        <Reveal delay={0.5}>
          <p className="mt-12 font-serif-display italic font-light text-2xl md:text-3xl text-[#7D1B56]">
            I am here. I am loved. I matter.
          </p>
        </Reveal>
      </div>
    </section>
  );
};
